import styled from 'styled-components';

interface HeaderTabsProps {
  active: boolean;
}

/**
 * @deprecated Please use TabHeader in atoms/TabHeader/TabHeader.tsx
 */

export const HeaderTab = styled.div<HeaderTabsProps>`
  width: fit-content;
  padding: 12px 0;
  margin: 0 24px;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-size: 16px;
  font-weight: 500;
  border-bottom: 2px solid;
  border-bottom-color: ${(props) =>
    props.active
      ? props.theme.atlas.semantic.color.action.primary.default
      : props.theme.atlas.semantic.color.outline.active};
  cursor: pointer;

  color: ${({ theme }) => theme.atlas.semantic.color.type.muted};

  &:hover {
    color: ${({ theme }) => theme.atlas.semantic.color.type.muted};
  }
  transition: all ease-in-out 0.3s;
`;

export const HeaderTabsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 15px 0 0 12px;
  background: ${({ theme }) => theme.atlas.semantic.color.surface.default};
`;
